import {FC} from "react";
import {useAuthStatus} from "../../../hooks/useAuthStatus";
import {BlockTextCrgci} from "../SidebarCardUI/BlockTextCrgci";
import {BlockToggleGrayArrow} from "../../InfoExpand/BlockToggleGrayArrow";
import {StatusBlock} from "../SidebarCardUI/StatusBlock";
import {UserInfoCard} from "../SidebarCardUI/UserInfoCard";
import {BlockWithStars} from "../SidebarCardUI/BlockWithStars";
import {BlockComments} from "../SidebarCardUI/BlockComments";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {BlockTags} from "../SidebarCardUI/BlockTags";
import {TitleCard} from "../styles";
import {urlApiDataCRGCI, apiKeyDataCRGCI} from "../../../helper/api";
import {
  IinitiativeAllInfo,
  IPeople,
  ICRGCIResponse,
  ICRGCIInitiative,
  ICRGCIImpactArea,
  IInitiativeApiSingleResponse,
  IStrapiRichTextBlock,
} from "../../../pages/StateInitiative/StateInitiative.type";
import {ITypeRadar} from "../../../types";

// Функция для конвертации Strapi rich text в обычный текст
const convertStrapiRichTextToString = (
  richText: IStrapiRichTextBlock[] | string | any
): string => {
  if (!richText) return "";
  if (typeof richText === "string") return richText;
  if (Array.isArray(richText)) {
    return richText
      .map((block: any) => {
        if (block.type === "paragraph" && block.children) {
          return block.children.map((child: any) => child.text || "").join("");
        }
        return "";
      })
      .join(" ")
      .trim();
  }
  return "";
};

// Функция для проверки, является ли значение пустым
const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (Array.isArray(value) && value.length === 0) return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return false;
};

const ImgMockUser = "/mocks/no-name.png";
const roleMock = "internal";

interface IProps {
  isLogin?: boolean;
  role?: string | null;
  setIsOpenSideBarStackHolders?: (value: boolean) => void;
  data?: IinitiativeAllInfo;
  initiativeData?: IInitiativeApiSingleResponse;
  typeRadar?: ITypeRadar;
  colorTitle?: string;
  setActiveWorker?: (value: IPeople) => void;
  setIdWorkerShowConnections?: (id: string) => void;
  crgciData?: ICRGCIResponse | null;
}

export const SidebarContentStateInitiativeBasic: FC<IProps> = ({
  isLogin,
  role,
  setIsOpenSideBarStackHolders,
  data,
  initiativeData,
  typeRadar,
  colorTitle,
  setActiveWorker,
  setIdWorkerShowConnections,
  crgciData,
}) => {
  const apiInitiative = initiativeData?.data?.[0];
  const currentInitiative = apiInitiative || data;

  const [isAuth, , roleAuth, , userIdAuth] = useAuthStatus([]);

  const crgciInitiative =
    data &&
    crgciData?.data?.initiatives?.find(
      (initiative: ICRGCIInitiative) => initiative.name === data.name
    );

  const hasApiData = Boolean(
    apiInitiative &&
      (apiInitiative.lifecycle_stage || apiInitiative.initiator_org)
  );

  const legalBasisContent =
    hasApiData && apiInitiative?.legal_basis?.length
      ? apiInitiative.legal_basis.flatMap((basis) => basis.content || [])
      : null;

  const handleClickOnWorker = (worker: IPeople) => {
    if (setIsOpenSideBarStackHolders) setIsOpenSideBarStackHolders(true);
    if (setActiveWorker) setActiveWorker(worker);
    if (setIdWorkerShowConnections)
      setIdWorkerShowConnections(worker.documentId);
  };

  if (!apiInitiative && !currentInitiative) {
    return (
      <div style={{color: "#fafafa", padding: "20px"}}>
        Данные инициативы не найдены
      </div>
    );
  }

  if (initiativeData) {
    return (
      <div style={{width: "100%", height: "100%", color: "#fafafa"}}>
        <TitleCard color={colorTitle}>
          {apiInitiative?.name ||
            currentInitiative?.name ||
            crgciInitiative?.name ||
            "Название недоступно"}
        </TitleCard>
        <br />
        <BlockDescription
          text={
            apiInitiative?.description ||
            currentInitiative?.description ||
            crgciInitiative?.description ||
            data?.description ||
            "Описание недоступно"
          }
          type="description"
        />
        <br />

        {isLogin &&
          ((hasApiData &&
            ((apiInitiative?.initiator_org &&
              apiInitiative.initiator_org.name) ||
              (apiInitiative?.contacts &&
                apiInitiative?.contacts.length > 0))) ||
            (!hasApiData &&
              data?.stakeholders &&
              data?.stakeholders.length > 0)) && (
            <div
              style={{
                fontSize: "16px",
                color: "rgba(255, 255, 255, 0.6)",
                marginBottom: 10,
              }}
            >
              Инициатор / куратор
            </div>
          )}

        {isLogin &&
          ((hasApiData &&
            ((apiInitiative?.initiator_org &&
              apiInitiative.initiator_org.name) ||
              (apiInitiative?.contacts &&
                apiInitiative?.contacts.length > 0))) ||
            (!hasApiData &&
              data?.stakeholders &&
              data?.stakeholders.length > 0)) && (
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>
              {hasApiData &&
                apiInitiative?.initiator_org &&
                apiInitiative.initiator_org.name && (
                  <div
                    style={{
                      color: "white",
                      width: "100%",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "12px",
                      padding: "12px 16px",
                      backgroundColor: "#22272B",
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <div style={{color: "#FAFAFA", fontSize: 16}}>
                        {apiInitiative.initiator_org.name}
                      </div>
                    </div>
                  </div>
                )}

              {!hasApiData &&
                data?.stakeholders &&
                data?.stakeholders
                  ?.slice(0, 1)
                  .map((item) => (
                    <UserInfoCard
                      key={item.id}
                      imageSrc={ImgMockUser}
                      department={item.department}
                      fullName={item.fullName}
                      role={item.role}
                      onClick={() => handleClickOnWorker(item)}
                    />
                  ))}
            </div>
          )}
        {isLogin &&
          ((hasApiData &&
            ((apiInitiative?.initiator_org &&
              apiInitiative.initiator_org.name) ||
              (apiInitiative?.contacts &&
                apiInitiative?.contacts.length > 0))) ||
            (!hasApiData &&
              data?.stakeholders &&
              data?.stakeholders.length > 0)) && <br />}

        {!isEmpty(
          hasApiData
            ? apiInitiative?.legal_basis
            : convertStrapiRichTextToString(crgciInitiative?.sources)
        ) && (
          <>
            <BlockTextCrgci
              title="Нормативная база"
              text={legalBasisContent || crgciInitiative?.sources || "Информация недоступна"}
            />
            <br />
          </>
        )}

        {!isEmpty(
          hasApiData
            ? apiInitiative?.lifecycle_stage
            : crgciInitiative?.lifecycle_stage
        ) && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                color: "white",
                fontSize: 14,
              }}
            >
              <div>Этап жизненного цикла</div>
              <div>
                {hasApiData
                  ? apiInitiative?.lifecycle_stage || "Не указан"
                  : crgciInitiative?.lifecycle_stage || "Не указан"}
              </div>
            </div>
            <br />
          </>
        )}

        {(!isEmpty(
          convertStrapiRichTextToString(
            hasApiData
              ? apiInitiative?.publication_date
              : crgciInitiative?.publication_date
          )
        ) ||
          !isEmpty(
            convertStrapiRichTextToString(
              hasApiData
                ? apiInitiative?.effective_milestones
                : crgciInitiative?.effective_milestones
            )
          ) ||
          !isEmpty(
            convertStrapiRichTextToString(
              hasApiData
                ? apiInitiative?.company_deadlines
                : crgciInitiative?.company_deadlines
            )
          ) ||
          (isLogin &&
            !isEmpty(
              convertStrapiRichTextToString(
                hasApiData
                  ? apiInitiative?.planned_updates
                  : crgciInitiative?.planned_updates
              )
            ))) && (
          <>
            <BlockToggleGrayArrow
              data={
                <>
                  {!isEmpty(
                    convertStrapiRichTextToString(
                      hasApiData
                        ? apiInitiative?.publication_date
                        : crgciInitiative?.publication_date
                    )
                  ) && (
                    <BlockTextCrgci
                      title="Дата публикации / старта"
                      text={
                        (hasApiData
                          ? apiInitiative?.publication_date
                          : crgciInitiative?.publication_date) || "Не указана"
                      }
                    />
                  )}
                  {!isEmpty(
                    convertStrapiRichTextToString(
                      hasApiData
                        ? apiInitiative?.effective_milestones
                        : crgciInitiative?.effective_milestones
                    )
                  ) && (
                    <BlockTextCrgci
                      title="Срок вступления в силу"
                      text={
                        (hasApiData
                          ? apiInitiative?.effective_milestones
                          : crgciInitiative?.effective_milestones) || "Не указан"
                      }
                    />
                  )}
                  {!isEmpty(
                    convertStrapiRichTextToString(
                      hasApiData
                        ? apiInitiative?.company_deadlines
                        : crgciInitiative?.company_deadlines
                    )
                  ) && (
                    <BlockTextCrgci
                      title="Дедлайны для компаний"
                      text={
                        (hasApiData
                          ? apiInitiative?.company_deadlines
                          : crgciInitiative?.company_deadlines) || "Не указаны"
                      }
                    />
                  )}
                  {isLogin &&
                    !isEmpty(
                      convertStrapiRichTextToString(
                        hasApiData
                          ? apiInitiative?.planned_updates
                          : crgciInitiative?.planned_updates
                      )
                    ) && (
                      <BlockTextCrgci
                        title="Плановые этапы обновлений"
                        text={
                          (hasApiData
                            ? apiInitiative?.planned_updates
                            : crgciInitiative?.planned_updates) || "Не указаны"
                        }
                      />
                    )}
                </>
              }
              title="Временные параметры"
              typeRadar={typeRadar}
            />
            <br />
          </>
        )}
        {isLogin && (
          <>
            {((apiInitiative?.impact_areas &&
              apiInitiative.impact_areas.length > 0) ||
              (crgciInitiative?.impact_areas &&
                crgciInitiative.impact_areas.length > 0) ||
              !isEmpty(
                hasApiData
                  ? apiInitiative?.obligation_level
                  : crgciInitiative?.obligation_level
              ) ||
              !isEmpty(
                hasApiData
                  ? apiInitiative?.business_impact
                  : crgciInitiative?.business_impact
              ) ||
              !isEmpty(
                convertStrapiRichTextToString(
                  hasApiData
                    ? apiInitiative?.noncompliance_risks
                    : crgciInitiative?.noncompliance_risks
                )
              )) && (
              <>
                <BlockToggleGrayArrow
                  data={
                    <>
                      {((apiInitiative?.impact_areas &&
                        apiInitiative.impact_areas.length > 0) ||
                        (crgciInitiative?.impact_areas &&
                          crgciInitiative.impact_areas.length > 0)) && (
                        <BlockTags
                          tags={
                            apiInitiative?.impact_areas &&
                            apiInitiative.impact_areas.length > 0
                              ? apiInitiative.impact_areas.map(
                                  (area: ICRGCIImpactArea) =>
                                    area.name || "Неизвестно"
                                )
                              : crgciInitiative?.impact_areas &&
                                crgciInitiative.impact_areas.length > 0
                              ? crgciInitiative.impact_areas.map(
                                  (area: ICRGCIImpactArea) =>
                                    area.name || "Неизвестно"
                                )
                              : ["нет данных о зоне влияния"]
                          }
                          title="Зона влияния"
                        />
                      )}

                      {!isEmpty(
                        hasApiData
                          ? apiInitiative?.obligation_level
                          : crgciInitiative?.obligation_level
                      ) && (
                        <StatusBlock
                          title="Обязательность"
                          value={
                            hasApiData
                              ? apiInitiative?.obligation_level || "Не указано"
                              : crgciInitiative?.obligation_level ||
                                "Не указано"
                          }
                        />
                      )}
                      {!isEmpty(
                        hasApiData
                          ? apiInitiative?.business_impact
                          : crgciInitiative?.business_impact
                      ) && (
                        <BlockWithStars
                          priority={
                            (hasApiData
                              ? apiInitiative?.business_impact
                              : crgciInitiative?.business_impact) === "высокий"
                              ? "Высокий"
                              : (hasApiData
                                  ? apiInitiative?.business_impact
                                  : crgciInitiative?.business_impact) ===
                                "низкий"
                              ? "Низкий"
                              : "Средний"
                          }
                          title="Степень влияния на бизнес"
                        />
                      )}
                      {!isEmpty(
                        convertStrapiRichTextToString(
                          hasApiData
                            ? apiInitiative?.noncompliance_risks
                            : crgciInitiative?.noncompliance_risks
                        )
                      ) && (
                        <BlockTextCrgci
                          title="Риски несоблюдения"
                          text={
                            (hasApiData
                              ? apiInitiative?.noncompliance_risks
                              : crgciInitiative?.noncompliance_risks) || "Не указаны"
                          }
                        />
                      )}
                    </>
                  }
                  title="Оценка влияния (для приоритизации)"
                  typeRadar={typeRadar}
                />
                <br />
              </>
            )}

            {role === roleMock && (
              <>
                {((hasApiData && apiInitiative?.has_benefits !== undefined) ||
                  crgciInitiative?.has_benefits !== undefined ||
                  !isEmpty(
                    convertStrapiRichTextToString(
                      hasApiData
                        ? apiInitiative?.benefits_desc
                        : crgciInitiative?.benefits_desc
                    )
                  ) ||
                  !isEmpty(
                    convertStrapiRichTextToString(
                      hasApiData
                        ? apiInitiative?.direct_costs
                        : crgciInitiative?.direct_costs
                    )
                  ) ||
                  (hasApiData
                    ? apiInitiative?.roi_expected_for_voluntary !== undefined
                    : crgciInitiative?.roi_expected_for_voluntary !==
                      undefined)) && (
                  <>
                    <BlockToggleGrayArrow
                      data={
                        <>
                          {((hasApiData &&
                            apiInitiative?.has_benefits !== undefined) ||
                            crgciInitiative?.has_benefits !== undefined) && (
                            <StatusBlock
                              title="Возможные льготы и субсидии"
                              value={
                                (
                                  hasApiData &&
                                  apiInitiative?.has_benefits !== undefined
                                    ? apiInitiative?.has_benefits
                                    : crgciInitiative?.has_benefits
                                )
                                  ? "Да"
                                  : "Нет"
                              }
                            />
                          )}
                          {!isEmpty(
                            convertStrapiRichTextToString(
                              hasApiData
                                ? apiInitiative?.benefits_desc
                                : crgciInitiative?.benefits_desc
                            )
                          ) && (
                            <BlockTextCrgci
                              title="Описание льгот и субсидий"
                              text={
                                (hasApiData
                                  ? apiInitiative?.benefits_desc
                                  : crgciInitiative?.benefits_desc) || "Не указано"
                              }
                            />
                          )}
                          {!isEmpty(
                            convertStrapiRichTextToString(
                              hasApiData
                                ? apiInitiative?.direct_costs
                                : crgciInitiative?.direct_costs
                            )
                          ) && (
                            <BlockTextCrgci
                              title="Прямые затраты на выполнение (оценка в диапазоне)"
                              text={
                                (hasApiData
                                  ? apiInitiative?.direct_costs
                                  : crgciInitiative?.direct_costs) || "Не указаны"
                              }
                            />
                          )}
                          {(hasApiData
                            ? apiInitiative?.roi_expected_for_voluntary !==
                              undefined
                            : crgciInitiative?.roi_expected_for_voluntary !==
                              undefined) && (
                            <StatusBlock
                              title="Окупаемость участия"
                              value={
                                (
                                  hasApiData
                                    ? apiInitiative?.roi_expected_for_voluntary
                                    : crgciInitiative?.roi_expected_for_voluntary
                                )
                                  ? "Да"
                                  : "Нет"
                              }
                            />
                          )}
                        </>
                      }
                      title="Финансово-экономические параметры"
                      typeRadar={typeRadar}
                    />
                    <br />
                  </>
                )}
              </>
            )}

            {role === roleMock && (
              <>
                {(!isEmpty(
                  hasApiData
                    ? apiInitiative?.participation_formats
                    : crgciInitiative?.participation_formats
                ) ||
                  (isAuth &&
                    hasApiData &&
                    apiInitiative?.contacts &&
                    apiInitiative?.contacts.length > 0) ||
                  !isEmpty(
                    hasApiData
                      ? apiInitiative?.lobbying_opportunity
                      : crgciInitiative?.lobbying_opportunity
                  )) && (
                  <>
                    <BlockToggleGrayArrow
                      data={
                        <>
                          {!isEmpty(
                            hasApiData
                              ? apiInitiative?.participation_formats
                              : crgciInitiative?.participation_formats
                          ) && (
                            <StatusBlock
                              title="Форматы участия компании"
                              value={
                                hasApiData
                                  ? apiInitiative?.participation_formats ||
                                    "Не указано"
                                  : crgciInitiative?.participation_formats ||
                                    "Не указано"
                              }
                            />
                          )}

                          {/* Контакты */}
                          {isAuth &&
                            hasApiData &&
                            apiInitiative?.contacts &&
                            apiInitiative?.contacts.length > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 8,
                                }}
                              >
                                <div
                                  style={{
                                    color: "rgba(255, 255, 255, 0.6)",
                                    fontSize: 15,
                                  }}
                                >
                                  Контактные госорганы / лица
                                </div>
                                {apiInitiative?.contacts
                                  ?.slice(0, 2)
                                  .map((contact: any) => (
                                    <UserInfoCard
                                      key={contact.id}
                                      imageSrc={ImgMockUser}
                                      department={contact.department}
                                      fullName={contact.fullName}
                                      role={
                                        contact.jobFunction ||
                                        contact.interactionLevel ||
                                        ""
                                      }
                                      onClick={() => {}}
                                    />
                                  ))}
                              </div>
                            )}

                          {!isEmpty(
                            hasApiData
                              ? apiInitiative?.lobbying_opportunity
                              : crgciInitiative?.lobbying_opportunity
                          ) && (
                            <BlockWithStars
                              priority={
                                (hasApiData
                                  ? apiInitiative?.lobbying_opportunity
                                  : crgciInitiative?.lobbying_opportunity) ===
                                  "Высокая" ||
                                (hasApiData
                                  ? apiInitiative?.lobbying_opportunity
                                  : crgciInitiative?.lobbying_opportunity) ===
                                  "высокая"
                                  ? "Высокий"
                                  : (hasApiData
                                      ? apiInitiative?.lobbying_opportunity
                                      : crgciInitiative?.lobbying_opportunity) ===
                                      "Низкая" ||
                                    (hasApiData
                                      ? apiInitiative?.lobbying_opportunity
                                      : crgciInitiative?.lobbying_opportunity) ===
                                      "низкая"
                                  ? "Низкий"
                                  : "Средний"
                              }
                              title="Возможность лоббирования изменений"
                            />
                          )}
                        </>
                      }
                      title="Участие и взаимодействие"
                      typeRadar={typeRadar}
                    />
                    <br />
                  </>
                )}
              </>
            )}

            {role === roleMock && (
              <>
                <BlockToggleGrayArrow
                  data={
                    <>
                      <StatusBlock
                        title="Тренд в радаре технологий "
                        value="Core"
                      />
                    </>
                  }
                  title="Технологическая составляющая"
                  typeRadar={typeRadar}
                />
                <br />
              </>
            )}

            {(!isEmpty(
              convertStrapiRichTextToString(
                hasApiData ? apiInitiative?.sources : crgciInitiative?.sources
              )
            ) ||
              (hasApiData
                ? apiInitiative?.updatedAt
                : crgciInitiative?.updatedAt) ||
              (isLogin &&
                role === roleMock &&
                hasApiData &&
                apiInitiative?.updated_by_owner)) && (
              <>
                <BlockToggleGrayArrow
                  data={
                    <>
                      {!isEmpty(
                        convertStrapiRichTextToString(
                          hasApiData
                            ? apiInitiative?.sources
                            : crgciInitiative?.sources
                        )
                      ) && (
                        <BlockTextCrgci
                          title="Источники информации"
                          text={
                            (hasApiData
                              ? apiInitiative?.sources
                              : crgciInitiative?.sources) || "Не указаны"
                          }
                        />
                      )}
                      {(hasApiData
                        ? apiInitiative?.updatedAt
                        : crgciInitiative?.updatedAt) && (
                        <BlockTextCrgci
                          title="Дата последнего обновления карточки"
                          text={
                            (
                              hasApiData
                                ? apiInitiative?.updatedAt
                                : crgciInitiative?.updatedAt
                            )
                              ? new Date(
                                  hasApiData
                                    ? apiInitiative?.updatedAt!
                                    : crgciInitiative?.updatedAt!
                                ).toLocaleDateString("ru-RU")
                              : "Не указана"
                          }
                        />
                      )}

                      {isLogin && role === roleMock && (
                        <div style={{marginTop: "16px"}}>
                          <div
                            style={{
                              color: "rgba(255, 255, 255, 0.6)",
                              fontSize: 15,
                              marginBottom: 8,
                            }}
                          >
                            Ответственный за обновление (внутри компании)
                          </div>
                          {hasApiData && apiInitiative?.updated_by_owner ? (
                            <UserInfoCard
                              imageSrc={ImgMockUser}
                              department={
                                apiInitiative.updated_by_owner.department ||
                                "Не указан"
                              }
                              fullName={
                                apiInitiative.updated_by_owner.fullName ||
                                apiInitiative.updated_by_owner.username ||
                                "Не указано"
                              }
                              role={
                                apiInitiative.updated_by_owner.role ||
                                "Не указана"
                              }
                              onClick={() => {}}
                            />
                          ) : (
                            <div
                              style={{
                                color: "rgba(255, 255, 255, 0.4)",
                                fontSize: 14,
                                fontStyle: "italic",
                              }}
                            >
                              Нет информации
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  }
                  title="Источники и обновляемость"
                  typeRadar={typeRadar}
                />
                <br />
              </>
            )}

            {isLogin && role === roleMock && (
              <>
                {!isEmpty(apiInitiative?.comments) &&
                apiInitiative?.comments &&
                apiInitiative?.comments.length > 0 ? (
                  <BlockComments
                    initialComments={
                      apiInitiative?.comments?.map((comment) => ({
                        id: comment.documentId,
                        worker:
                          comment.author?.username ||
                          "Неизвестный пользователь",
                        text: comment.content,
                        date: new Date(comment.createdAt).toLocaleDateString(
                          "ru-RU",
                          {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                          }
                        ),
                        avatar: "/mocks/no-name.png",
                      })) || []
                    }
                    apiUrl={urlApiDataCRGCI}
                    apiKey={apiKeyDataCRGCI}
                    initiativeId={apiInitiative?.documentId}
                    authorId={userIdAuth || "2"} // Используем реальный ID или fallback
                    currentUserName={roleAuth || "internal"} // Используем реальное имя или fallback
                  />
                ) : (
                  <BlockComments
                    initialComments={[]}
                    apiUrl={urlApiDataCRGCI}
                    apiKey={apiKeyDataCRGCI}
                    initiativeId={apiInitiative?.documentId}
                    authorId={userIdAuth || "2"} // Используем реальный ID или fallback
                    currentUserName={roleAuth || "internal"} // Используем реальное имя или fallback
                  />
                )}
              </>
            )}
          </>
        )}
      </div>
    );
  }

  if (!data) {
    return (
      <div style={{color: "#fafafa", padding: "20px"}}>
        Данные инициативы не найдены
      </div>
    );
  }

  return (
    <div style={{width: "100%", height: "100%", color: "#fafafa"}}>
      <TitleCard color={colorTitle}>{data.name}</TitleCard>
      <br />
      <BlockDescription text={data.description} type="description" />

      {data.segment && !isEmpty(data.segment.name) && (
        <>
          <br />
          <BlockTextCrgci
            text={`Сегмент: ${data.segment.name}`}
            title="Информация о сегменте"
          />
        </>
      )}

      {!isEmpty(data.maturity) && (
        <>
          <br />
          <BlockTextCrgci
            text={`Уровень зрелости: ${data.maturity}`}
            title="Зрелость инициативы"
          />
        </>
      )}

      {!isEmpty(data.priority) && (
        <>
          <br />
          <BlockTextCrgci
            text={`Приоритет: ${data.priority}`}
            title="Приоритет"
          />
        </>
      )}

      {data.gpb !== undefined && (
        <>
          <br />
          <BlockTextCrgci
            text={data.gpb ? "Входит в ГПБ" : "Не входит в ГПБ"}
            title="Статус ГПБ"
          />
        </>
      )}
    </div>
  );
};
